import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "customerCreateModal",
  tabindex: "-1",
  "aria-labelledby": "customerCreateModalLabel",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered modal-lg" }
const _hoisted_3 = { class: "modal-content border-0 shadow" }
const _hoisted_4 = { class: "modal-header border-bottom-dashed" }
const _hoisted_5 = { class: "modal-chip" }
const _hoisted_6 = {
  class: "modal-title fw-bold mt-3 mb-1",
  id: "customerCreateModalLabel"
}
const _hoisted_7 = { class: "text-muted mb-0" }
const _hoisted_8 = ["aria-label"]
const _hoisted_9 = { class: "modal-body p-4 p-xl-40" }
const _hoisted_10 = { class: "row g-3" }
const _hoisted_11 = { class: "col-md-6" }
const _hoisted_12 = { class: "field-header" }
const _hoisted_13 = { class: "form-label fw-semibold text-title mb-0" }
const _hoisted_14 = { class: "field-caption" }
const _hoisted_15 = { class: "reference-input-wrap" }
const _hoisted_16 = ["placeholder"]
const _hoisted_17 = ["disabled"]
const _hoisted_18 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_19 = { class: "col-md-6" }
const _hoisted_20 = { class: "field-header" }
const _hoisted_21 = { class: "form-label fw-semibold text-title mb-0" }
const _hoisted_22 = { class: "field-caption" }
const _hoisted_23 = ["placeholder"]
const _hoisted_24 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_25 = { class: "col-md-6" }
const _hoisted_26 = { class: "field-header" }
const _hoisted_27 = { class: "form-label fw-semibold text-title mb-0" }
const _hoisted_28 = { class: "field-caption" }
const _hoisted_29 = ["placeholder"]
const _hoisted_30 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_31 = { class: "col-md-6" }
const _hoisted_32 = { class: "field-header" }
const _hoisted_33 = { class: "form-label fw-semibold text-title mb-0" }
const _hoisted_34 = { class: "field-caption" }
const _hoisted_35 = ["placeholder"]
const _hoisted_36 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_37 = { class: "col-md-6" }
const _hoisted_38 = { class: "field-header" }
const _hoisted_39 = { class: "form-label fw-semibold text-title mb-0" }
const _hoisted_40 = { class: "field-caption" }
const _hoisted_41 = ["placeholder"]
const _hoisted_42 = { class: "col-md-6" }
const _hoisted_43 = { class: "field-header" }
const _hoisted_44 = { class: "form-label fw-semibold text-title mb-0" }
const _hoisted_45 = { class: "field-caption" }
const _hoisted_46 = { value: 1 }
const _hoisted_47 = { value: 0 }
const _hoisted_48 = { class: "col-12" }
const _hoisted_49 = { class: "field-header" }
const _hoisted_50 = { class: "form-label fw-semibold text-title mb-0" }
const _hoisted_51 = { class: "field-caption" }
const _hoisted_52 = ["placeholder"]
const _hoisted_53 = { class: "d-flex justify-content-between align-items-center mt-4 pt-2" }
const _hoisted_54 = {
  type: "button",
  class: "btn btn-light px-4",
  "data-bs-dismiss": "modal"
}
const _hoisted_55 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", null, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.customer ? _ctx.$t("customer_page.edit_customer_chip") : _ctx.$t("customer_page.new_customer")), 1),
            _createElementVNode("h5", _hoisted_6, _toDisplayString(_ctx.customer ? _ctx.$t("customer_page.update_customer") : _ctx.$t("customer_page.create_customer")), 1),
            _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("customer_page.modal_description")), 1)
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "btn-close shadow-none",
            "data-bs-dismiss": "modal",
            "aria-label": _ctx.$t('common.close')
          }, null, 8, _hoisted_8)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("form", {
            onSubmit: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$t("customer_page.customer_code")), 1),
                  _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t("customer_page.customer_code_caption")), 1)
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.code) = $event)),
                    type: "text",
                    class: _normalizeClass(["form-control modal-input", { 'is-invalid': _ctx.fieldErrors.code }]),
                    placeholder: _ctx.$t('customer_page.customer_code_placeholder'),
                    required: ""
                  }, null, 10, _hoisted_16), [
                    [_vModelText, _ctx.formData.code]
                  ]),
                  (!_ctx.customer)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "btn btn-light generate-code-btn",
                        disabled: _ctx.loading,
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.generateCustomerCode && _ctx.generateCustomerCode(...args)))
                      }, [
                        _cache[9] || (_cache[9] = _createElementVNode("i", { class: "ri-refresh-line me-1" }, null, -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t("customer_page.generate")), 1)
                      ], 8, _hoisted_17))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.fieldErrors.code)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_ctx.fieldErrors.code), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.$t("customer_page.customer_name")), 1),
                  _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$t("customer_page.customer_name_caption")), 1)
                ]),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.name) = $event)),
                  type: "text",
                  class: _normalizeClass(["form-control modal-input", { 'is-invalid': _ctx.fieldErrors.name }]),
                  placeholder: _ctx.$t('customer_page.customer_name_placeholder'),
                  required: ""
                }, null, 10, _hoisted_23), [
                  [_vModelText, _ctx.formData.name]
                ]),
                (_ctx.fieldErrors.name)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(_ctx.fieldErrors.name), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("label", _hoisted_27, _toDisplayString(_ctx.$t("customer_page.email")), 1),
                  _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.$t("customer_page.email_caption")), 1)
                ]),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.email) = $event)),
                  type: "email",
                  class: _normalizeClass(["form-control modal-input", { 'is-invalid': _ctx.fieldErrors.email }]),
                  placeholder: _ctx.$t('customer_page.email_placeholder')
                }, null, 10, _hoisted_29), [
                  [_vModelText, _ctx.formData.email]
                ]),
                (_ctx.fieldErrors.email)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString(_ctx.fieldErrors.email), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("label", _hoisted_33, _toDisplayString(_ctx.$t("customer_page.phone")), 1),
                  _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.$t("customer_page.phone_caption")), 1)
                ]),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.phone) = $event)),
                  type: "text",
                  class: _normalizeClass(["form-control modal-input", { 'is-invalid': _ctx.fieldErrors.phone }]),
                  placeholder: _ctx.$t('customer_page.phone_placeholder')
                }, null, 10, _hoisted_35), [
                  [_vModelText, _ctx.formData.phone]
                ]),
                (_ctx.fieldErrors.phone)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_36, _toDisplayString(_ctx.fieldErrors.phone), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("label", _hoisted_39, _toDisplayString(_ctx.$t("customer_page.country")), 1),
                  _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.$t("customer_page.country_caption")), 1)
                ]),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.country) = $event)),
                  type: "text",
                  class: "form-control modal-input",
                  placeholder: _ctx.$t('customer_page.country_value_placeholder')
                }, null, 8, _hoisted_41), [
                  [_vModelText, _ctx.formData.country]
                ])
              ]),
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("div", _hoisted_43, [
                  _createElementVNode("label", _hoisted_44, _toDisplayString(_ctx.$t("customer_page.status")), 1),
                  _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.$t("customer_page.status_caption")), 1)
                ]),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.status) = $event)),
                  class: "form-select modal-input"
                }, [
                  _createElementVNode("option", _hoisted_46, _toDisplayString(_ctx.$t("customer_page.status_active")), 1),
                  _createElementVNode("option", _hoisted_47, _toDisplayString(_ctx.$t("customer_page.status_inactive")), 1)
                ], 512), [
                  [_vModelSelect, _ctx.formData.status]
                ])
              ]),
              _createElementVNode("div", _hoisted_48, [
                _createElementVNode("div", _hoisted_49, [
                  _createElementVNode("label", _hoisted_50, _toDisplayString(_ctx.$t("customer_page.address")), 1),
                  _createElementVNode("span", _hoisted_51, _toDisplayString(_ctx.$t("customer_page.address_caption")), 1)
                ]),
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.address) = $event)),
                  rows: "4",
                  class: "form-control modal-input modal-textarea",
                  placeholder: _ctx.$t('customer_page.address_placeholder')
                }, null, 8, _hoisted_52), [
                  [_vModelText, _ctx.formData.address]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_53, [
              _createElementVNode("button", _hoisted_54, _toDisplayString(_ctx.$t("common.cancel")), 1),
              _createElementVNode("button", {
                type: "submit",
                class: "btn style-one px-4 h-55",
                disabled: _ctx.loading
              }, _toDisplayString(_ctx.loading ? _ctx.$t("customer_page.saving") : _ctx.customer ? _ctx.$t("customer_page.update_customer") : _ctx.$t("customer_page.create_customer")), 9, _hoisted_55)
            ])
          ], 32)
        ])
      ])
    ])
  ]))
}